<template lang="pug">
  .swiper
    div.publicities(ref="publicities")
      transition-group(name="publicity" tag="div"
        :enter-active-class="enterActiveClass"
        :leave-active-class="leaveActiveClass"
        :enter-class="enterClass"
        :enter-to-class="enterToClass"
        :leave-class="leaveClass"
        :leave-to-class="leaveToClass"
      )
        div.publicityList(v-for="item in publicity" :key="item.src" v-show="item.isActive")
          img.publicity( :src="item.src")
          div.publicityText(v-show="item.type && item.type === 'index'")
            h3 DATA ECONOMY ERA
            h1 HAMIS OS
            h2 数字经济时代的云智能操作系统
            router-link.linkBtn.bigLinkBtn(:to="{name: 'GuestForm'}" @click="gotoExperience") 立即体验

    .pageShow
      .pageItem(v-for="(item, index) in publicity" :class="{isNow: nowPage === index}" @click="scrollCtl(index)")

    button.play(type="text" @click="showVideo" v-show="publicity[nowPage].type && publicity[nowPage].type === 'index'")
      .playIcon
    
    button.leftButton(type="text" @click="scrollCtl('left')")
      .icon
    button.rightButton(type="text" @click="scrollCtl('right')")
      .icon
    
    video-player(ref="videoPlayer" v-show="videoIsShow")
  
    .downArrow()
      div

</template>

<script>
  import _ from 'lodash';
  import VideoPlayer from "@/views/Home/swiper/player/player";
  import {debounce} from "@/utils/utils";

  const Debounce = debounce(3100);

  export default {
    name: "mainSwiper",
    components: {VideoPlayer},
    data() {
      return {
        publicity: [
          {type: 'index', src: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E9%A6%96%E9%A1%B5banner.png', explain: '', isActive: true},
          {type: 'other', src: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E4%B8%8E%E9%93%BE%E4%B8%8A%E6%B5%B7%E5%8D%97%E5%90%88%E4%BD%9C.jpg', explain: '', isActive: false},
        ],
        nowPage: 0, // 从0开始计数
        interval: null,
        animationDelay: 20000, // 轮播动画的自动播放间隔时间，按毫秒记
        videoIsShow: false,

        enterClass: 'enterFromRight',
        enterActiveClass: 'publicityAnimationActive',
        enterToClass: 'moveEnd',
        leaveClass: 'moveEnd',
        leaveActiveClass: 'leaveActive',
        leaveToClass: 'leaveToLeft',
      };
    },
    watch: {
      nowPage(val, oldVal) {
        const page = Math.min(Math.max(val, 0), this.publicity.length - 1);
        const oldPage = Math.min(Math.max(oldVal, 0), this.publicity.length - 1);
        this.publicity[oldPage].isActive = false;
        this.publicity[page].isActive = true;
        // if (val < oldVal) {
        //   this.enterClass = 'enterFromLeft';
        //   this.leaveToClass = 'leaveToRight';
        // } else {
        //   this.enterClass = 'enterFromRight';
        //   this.leaveToClass = 'leaveToLeft';
        // }
      },
    },
    computed: {
      banners() {
        const banners = this.publicity.map(item => item);
        banners.push([...this.publicity[0]]);
        banners.unshift([...this.publicity[this.publicity.length - 1]]);
        return banners;
      },

      page: {
        get() {
          return this.nowPage;
        },
        set(val) {
          this.nowPage = (val + this.publicity.length) % this.publicity.length;
        },
      },
    },
    methods: {
      gotoExperience() {
        // this.$router.push({name: 'GuestForm'});
        window.scrollTo(0, 0);
      },
      scrollCtl(params) {
        if (_.isNumber(params)) {
          if (params > this.nowPage) {
            this.enterClass = 'enterFormRight';
            this.leaveToClass = 'leaveToLeft';
          } else {
            this.enterClass= 'enterFormLeft';
            this.leaveToClass = 'leaveToRight';
          }
          Debounce(() => this.nowPage = params);
          return;
        }
        switch (params) {
          case 'left':
            Debounce(() => this.page--);
            this.resetInterval();
            this.enterClass= 'enterFormLeft';
            this.leaveToClass = 'leaveToRight';
            // this.page--;
            break;
          case 'right':
            Debounce(() => this.page++);
            this.resetInterval();
            this.enterClass = 'enterFormRight';
            this.leaveToClass = 'leaveToLeft';
            // this.page++;
            break;
          default:
            break;
        }
      },
      resetInterval() {
        clearInterval(this.interval);
        this.interval = setInterval(() => Debounce(() => this.page = (this.page + 1) % this.publicity.length), this.animationDelay)
      },
      showVideo() {
        this.videoIsShow = true;
        this.$refs['videoPlayer'].play();
      },
      closeVideo() {
        this.videoIsShow = false;
      },
    },
    mounted() {
      this.interval = setInterval(() => Debounce(() => this.page = (this.page + 1) % this.publicity.length), this.animationDelay)
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  @keyframes slideInDown {
    0% {
      transform translateY(-100%)
    }
    100% {
      transform translateY(100%)
    }
  }
  .swiper {
    position relative
    width 100%
    
    .publicities {
      width 100%
      overflow hidden
      position relative
      .enterFromLeft {
        transform translate(-100%);
        position absolute
      }
      .enterFromRight {
        transform translate(100%);
        position absolute
      }
      .leaveToLeft {
        transform translate(-100%);
        position absolute
      }
      .leaveToRight {
        transform translate(100%);
        position absolute
      }
      .moveEnd {
        transform translate(0);
      }
      .leaveActive {
        position absolute
        z-index 2
        transition all 1s
        top 0
        left 0
        height 100%
        width 100%
      }
      .publicityAnimationActive {
        transition all 1s
      }
      .publicity {
        width 100%
        //filter brightness(50%)
        MinWidth()
      }
      .publicityList {
        max-height 45.3125vw
        min-height 600px
      }
    }
    
    .publicityText {
      position absolute
      height 266px
      top calc(50% - 133px)
      left 276px
      display flex
      flex-direction column
      align-items flex-start
      justify-content flex-start
      color white
      
      h1, h2, h3 {
        color white
        margin 0
        &::after {
          content none
        }
      }
      
      h3 {
        font-size 13px
        FontSetting(Montserrat)
        font-weight lighter
      }
      
      h1 {
        font-size 80px
        FontSetting(Montserrat)
        font-weight bold
        margin-left -5px
      }
      
      h2 {
        font-size 24px
        FontSetting("思源黑体 CN Regular")
      }
      
      .linkBtn {
        margin-top auto
      }
    }
    
    
    .leftButton, .rightButton {
      position absolute
      background-color rgba(255, 255, 255, .2)
      border 0
      width 4.6875vw
      height @width
      border-radius 50%
      top calc(50% - 45px)
      display flex
      align-items center
      justify-content center
      @media screen and (min-width 600px) {
      
      }
      
      .icon {
        width 26px
        height 2px
        background-color white
        position relative
        
        &::before, &::after {
          content ""
          position absolute
          width 13px
          height 2px
          background-color white
        }
      }
    }
    
    .leftButton {
      left 80px
      
      .icon {
        &::before, &::after {
          left -2px
        }
        
        &::before {
          top -4px
          transform rotate(-45deg)
        }
        
        &::after {
          top 4px
          transform rotate(45deg)
        }
      }
    }
    
    .rightButton {
      right 80px
      
      .icon {
        &::before, &::after {
          right -2px
        }
        
        &::before {
          top -4px
          transform rotate(45deg)
        }
        
        &::after {
          top 4px
          transform rotate(-45deg)
        }
      }
    }
    
    .play {
      position absolute
      height 64px
      width 64px
      background-color rgba(0, 0, 0, .4)
      border-radius 50%
      border 1px solid rgba(255, 255, 255, .4)
      top calc(50% - 32px)
      left calc(50% - 32px)
      
      .playIcon {
        position absolute
        width 2px
        height 20px
        left calc(50% - 6px)
        top calc(50% - 10px)
        background-color white
        
        &::before, &::after {
          position absolute
          content ""
          width 20px
          height 2px
          right -17px
          background-color white
        }
        
        &::before {
          top calc(50% - 6px)
          transform rotate(30deg)
        }
        
        &::after {
          bottom calc(50% - 6px)
          transform rotate(-30deg)
        }
      }
    }
    
    .publicity {
      /*max-height 100%;*/
    }
    
    .pageShow {
      position absolute
      bottom 50px
      width 300px
      left calc(50% - 150px)
      display flex
      align-items center
      justify-content center
      
      .pageItem {
        height 12px
        width @height
        border-radius 50%
        margin 5px
        background-color rgba(255, 255, 255, .3)
        cursor pointer
      }
      
      .isNow {
        background-color transparent
        border 1px solid #fff
      }
    }
  }
  .player {
    position absolute
    top 150px
    left 300px
    width calc(100% - 600px)
    height calc(100% - 300px)
  }
  .downArrow {
    position absolute
    display none
    bottom 20px
    left calc(50% - 30px)
    height 60px
    width 60px
    background-color transparent
    overflow hidden
    mask url("../../../assets/images/竖线.png") no-repeat center
    mask-size 100% 100%
    > div {
      height 100%
      width 100%
      background-color #fff
      position relative
      animation slideInDown infinite 3s
    }
  }

  .bigLinkBtn {
    height 48px
    width 168px
    border-radius 48px
    box-sizing border-box
    HStack(center, center)
    margin-top 60px
    
  }

  @media (max-width: ipadProScreenWidth) {
    .swiper {
      .publicityText {
        left 70px
      }
    }
  }
  @media (max-width 1022px) {
    .swiper {
      .play {
        top 345px
        z-index 30
      }
      .publicityText {
        height 300px
        top calc(50% - 140px)
        left calc(50% - 201px)
        .linkBtn {
          align-self center
        }
      }
    }
  }
  @media (max-width screenWidth) {
    .swiper {
      .downArrow {
        display block
      }
      .publicities {
        > div {
          position relative
          width 100vw
          &::after {
            position absolute
            mask url("../../../assets/images/上滑.png") no-repeat center
            height 40px
            width 40px
            mask-size 40px
            bottom 30px
            left calc(50% - 20px)
            background-color white
            z-index 3
            animation slide 3s ease-out infinite
          }
        }
        .publicity {
          position absolute
          top 0
          left 0
          z-index 0
          width 1920px
          animation swipe 120s infinite linear alternate
        }
      }
      .publicityText {
        top calc(50% - 266px / 2)
        left 0
        z-index 1
        width 100vw
        VStack(center)
        height 53%
        
        h3 {
          font-weight 300
        }
        h1 {
          font-size 60px
        }
        .bigLinkBtn {
          align-items center
          font-weight 600
          background-color #fff
          border-color #fff
          color #202020
          > * {
            color #202020
          }
        }
      }
      .pageShow {
        display none
      }
      .play {
        top 345px
        z-index 50
        /*display none*/
      }
      .player {
        width 100%
        left 0
        top 100px
      }
    }
  }
  @keyframes swipe {
    100% {
      left calc(100% - 1920px)
    }
  }
  @keyframes slide {
    100% {
      transform translateY(-20px)
      opacity 30%
    }
  }
</style>
